var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownCarrotWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8426 6.15893C11.1096 5.92034 11.5103 5.95426 11.7376 6.23468C11.9648 6.51511 11.9325 6.93585 11.6654 7.17445L7.96167 10.4832C7.84717 10.5855 7.539 10.8251 7.539 10.8251C7.539 10.8251 7.27253 10.5965 7.15215 10.4948L3.23685 7.18604C2.96368 6.95519 2.92046 6.53552 3.14032 6.24869C3.36018 5.96187 3.75986 5.91649 4.03303 6.14734L7.539 9.11019L10.8426 6.15893Z",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5678_64934",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 9,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8426 6.15893C11.1096 5.92034 11.5103 5.95426 11.7376 6.23468C11.9648 6.51511 11.9325 6.93585 11.6654 7.17445L7.96167 10.4832C7.84717 10.5855 7.539 10.8251 7.539 10.8251C7.539 10.8251 7.27253 10.5965 7.15215 10.4948L3.23685 7.18604C2.96368 6.95519 2.92046 6.53552 3.14032 6.24869C3.36018 5.96187 3.75986 5.91649 4.03303 6.14734L7.539 9.11019L10.8426 6.15893Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5678_64934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.73047,
    y: 2,
    width: 11.4286,
    height: 12,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownCarrotWhite);
export default __webpack_public_path__ + "static/media/down-carrot-white.650fe5f9790ece4c139d4fab66a7fe74.svg";
export { ForwardRef as ReactComponent };